import { Component } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { Router } from '@angular/router';
import { Pickup } from '../pickup/pickup';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  loadingPickups: boolean = true;
  completedPickupRows;
  pendingPickupRows;

  constructor(
    private db:     AngularFireDatabase,
    private router: Router
  ) {
    db.list('/pickups').subscribe(
      data => {
        console.log(data);
        this.buildTable(data);
      }
    );
  }

  private buildTable(data: Array<Pickup>): void {
    this.completedPickupRows = [];
    this.pendingPickupRows = [];
    for (var pickup of data) {
      if (pickup.pickedUp) {
        console.log('pickedUp', this.buildTableRow(pickup));
        this.completedPickupRows.push(this.buildTableRow(pickup));
      } else {
        console.log('not pickedUp', this.buildTableRow(pickup));
        this.pendingPickupRows.push(this.buildTableRow(pickup));
      }
    }
    this.loadingPickups = false;
    console.log(this.pendingPickupRows);
  }

  private buildTableRow(data) {
    return {
      latitude: data.latitude,
      longitude: data.longitude,
      timestamp: new Date(data.timestamp).toLocaleString(),
      id: data.$key
    };
  }

  onActivate(row) {
    this.router.navigate(['pickup/' + row.id]);
    console.log('id', row.id);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts